import { TextListingEntry } from '../PropertyAdEditor';
import { Dashboard } from './Dashboard';

export const TextListingEntryPage = () => (
  <Dashboard openLogIn>
    <TextListingEntry />
  </Dashboard>
);
